import { Box, Button } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import React from "react";

interface NewCheckInputControlsProps {
  onClickCancel: () => void;
  canAdd: boolean;
  onClickConfirm: () => void;
  onClickConfirmDefault: () => void;
  canAddDefault: boolean;
}

export function NewCheckInputControls(props: NewCheckInputControlsProps) {
  return (
    <Box className="horizontal-flex">
      <Button color={"error"} variant={"contained"} onClick={props.onClickCancel}>
        Cancel
      </Button>
      {props.canAddDefault && (
        <>
          <Button
            color={"success"}
            variant={"contained"}
            endIcon={<CheckIcon />}
            disabled={!props.canAdd}
            onClick={props.onClickConfirmDefault}
          >
            Add and keep default
          </Button>
          <Button
            color={"success"}
            variant={"contained"}
            endIcon={<CheckIcon />}
            disabled={!props.canAdd}
            onClick={props.onClickConfirm}
          >
            Add
          </Button>
        </>
      )}
      {!props.canAddDefault && (
        <>
          <Button
            color={"success"}
            variant={"contained"}
            endIcon={<CheckIcon />}
            disabled={!props.canAdd}
            onClick={props.onClickConfirm}
          >
            Add
          </Button>
        </>
      )}
    </Box>
  );
}
